import { combineReducers } from "redux";

import myAssessmentsReducer from "./slices/myAssessmentsSlice";
import assessmentsReducer from "../redux/slices/assessmentsSlice";
import authReducer from "../redux/slices/authSlice";
import companyReducer from "../redux/slices/companySlice";
import dashboard from "../redux/slices/dashboardSlice";
import interviewReducer from "../redux/slices/interviewSlice";
import postsReducer from "../redux/slices/postsSlice";
import resultDashboardReducer from "../redux/slices/resultDashboard";
import resumeReducer from "../redux/slices/resumeSlice";
import testsReducer from "../redux/slices/testsSlice";
import companiesReducer from "../redux/slices/companiesSlice";
import dashboardStatsReducer from "../redux/slices/dashboardStatsSlice";
import jobResumeStatsReducer from "../redux/slices/jobResumeStatsSlice";
import companyLocationsReducer from "../redux/slices/companyLocationsSlice";
import companyRegistrationReducer from "../redux/slices/companyRegistrationSlice";
import companyStatsReducer from "../redux/slices/companyStatsSlice";
import resumeStatsReducer from "../redux/slices/RecruitersSlice";
import recruitersTableReducer from "../redux/slices/recruitersTableSlice";
import userGuidesReducer from "../redux/slices/userGuidesSlice";
import serverStatusReducer from "./slices/serverStatusSlice";

/* ============================================================================
  Combine ALl Reducers
============================================================================= */
const rootReducer = combineReducers({
  auth: authReducer,
  companies: companiesReducer, // reducer
  dashboardStats: dashboardStatsReducer,
  jobResumeStats: jobResumeStatsReducer,
  companyLocations: companyLocationsReducer,
  companyRegistration: companyRegistrationReducer,
  companyStats: companyStatsReducer,
  company: companyReducer,
  posts: postsReducer,
  myAssessments: myAssessmentsReducer,
  resume: resumeReducer,
  tests: testsReducer,
  resultDashboard: resultDashboardReducer,
  interview: interviewReducer,
  assessments: assessmentsReducer,
  dashboard: dashboard,
  resumeStats: resumeStatsReducer,
  recruitersTable: recruitersTableReducer,
  userGuides: userGuidesReducer,
  serverStatus: serverStatusReducer,
});

export default rootReducer;
